import collapseTransition from './collapseTransition'
export default collapseTransition
